import { Clock, Users, FolderKanban, FileText, GanttChart, Sparkles } from 'lucide-react';

interface PromptCategory {
  id: string;
  title: string;
  description: string;
  prompts: string[];
}

export const researchCategories: PromptCategory[] = [
  {
    id: 'task-management',
    title: 'Task & Time Management',
    description: 'Optimize task prioritization and time allocation',
    prompts: [
      "Analyze task prioritization strategies for {project_type} projects",
      "Recommend time management techniques for {team_size} person teams",
      "Research best practices for agile task management in {industry}",
      "Investigate productivity optimization methods for remote teams",
      "Study effective deadline management approaches for complex projects"
    ]
  },
  {
    id: 'team-collaboration',
    title: 'Team Collaboration & Resource Allocation',
    description: 'Enhance team coordination and resource management',
    prompts: [
      "Research team collaboration tools and practices for {team_type} teams",
      "Analyze resource allocation strategies for {project_size} projects",
      "Study effective communication patterns in distributed teams",
      "Investigate team performance metrics and measurement methods",
      "Research conflict resolution techniques in project teams"
    ]
  },
  {
    id: 'project-planning',
    title: 'Project Planning & Execution',
    description: 'Streamline project planning and implementation',
    prompts: [
      "Research project planning methodologies for {industry} sector",
      "Analyze risk management strategies in {project_type} projects",
      "Study budget estimation techniques for {scale} projects",
      "Investigate project timeline optimization methods",
      "Research quality assurance practices in project delivery"
    ]
  },
  {
    id: 'documentation',
    title: 'Documentation & Knowledge Management',
    description: 'Improve documentation and knowledge sharing',
    prompts: [
      "Research documentation best practices for {project_type}",
      "Study knowledge management systems for technical teams",
      "Analyze documentation tools and platforms comparison",
      "Investigate automated documentation approaches",
      "Research document versioning and maintenance strategies"
    ]
  },
  {
    id: 'technology',
    title: 'Technology & Tools',
    description: 'Research technology solutions and tools',
    prompts: [
      "Compare {technology_stack} tools and frameworks",
      "Research emerging technologies in {industry} sector",
      "Analyze development tools for {team_size} teams",
      "Study DevOps practices and tools for {project_type}",
      "Investigate cloud solutions for {scale} applications"
    ]
  },
  {
    id: 'others',
    title: 'Custom Prompts',
    description: 'Your personalized collection of custom prompts',
    prompts: [] // This will be populated dynamically from custom_prompts table
  }
];